import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import SVG from 'react-inlinesvg'
import React from 'react'
import '../SenderId.scss'

interface Props {
  show: boolean
  handleClose: () => void
  onClickActionButton?: () => void
  showActionButton: boolean
}

const ModalDetailCustomNumber: React.FC<Props> = ({
  show,
  handleClose,
  onClickActionButton,
  showActionButton,
}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName='modal-sender-id-learn-more modal-dialog-centered mw-900px'
        fullscreen={'lg-down'}
      >
        <div className='modal-header'>
          <h2 className='fs-2'>Custom Number</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='col-md-6'>
              <p className='mb-4'>
                Use your own number for SMS to create a direct, personal touch. Messages feel
                natural, and customers can reply or call you instantly—no middleman, just smooth,
                uninterrupted communication that keeps conversations flowing effortlessly.
              </p>

              <h4 className='fw-bolder mb-3'>Perfect For</h4>
              <ul className='list-unstyled'>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>Reminders, follow-ups & updates</div>
                  </div>
                </li>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>Personalised & Direct customer engagement</div>
                  </div>
                </li>
                <li className='mb-2'>
                  <div className='d-flex'>
                    <div className='me-2'>
                      <SVG src='/media/svg/check.svg' style={{width: '100%'}} />
                    </div>
                    <div>Automated messages that feel personal</div>
                  </div>
                </li>
              </ul>
            </div>
            <div className='col-md-6 justify-content-center align-items-center d-flex'>
              <div className='card rounded-4 overflow-hidden'>
                <iframe
                  width='417'
                  height='240'
                  src='https://www.youtube.com/embed/5Ys4NLj8bng'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerPolicy='strict-origin-when-cross-origin'
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className='modal-footer border-top-0 d-flex justify-content-end text-end'>
          {showActionButton && (
            <button
              type='button'
              className='btn btn-lg px-5 py-3 text-white fw-bolder'
              style={{backgroundColor: '#6C5CE7', borderRadius: '8px'}}
              onClick={onClickActionButton}
            >
              Register custom number
            </button>
          )}
        </div>
      </Modal>
    </>
  )
}

export default ModalDetailCustomNumber
